/**
 * CSS class names Intercom watches for click events. Applying one of these to
 * an element wires it up to the corresponding workflow configured in the
 * Intercom dashboard — no JS handler needed.
 *
 * Prefer applying these via `cn(...)` so the class can be merged with the
 * element's own styles, e.g.
 *   `<span className={cn('ms-1', { [INTERCOM_TRIGGER.enterpriseChat]: true })} />`
 */
export const INTERCOM_TRIGGER = {
  enterpriseChat: 'intercom-enterprise-chat',
  onboardingChat: 'intercom-onboarding-chat',
  contact: 'trigger-intercom-contact',
  contactQuoting: 'trigger-intercom-contact-quoting',
  contactAnalytics: 'trigger-intercom-contact-analytics',
  changeAccount: 'intercom-change-account',
  aiAssistant: 'trigger-intercom-ai-assistant',
  inventoryFeature: 'intercom-inventory-feature',
  partnerSlack: 'intercom-box-3',
  partnerSupport: 'intercom-box-4',
} as const;
